import { ScrollArea, ScrollBar } from "@/components/primitives/scroll-area";
import { useTranslation } from "react-i18next";
import { usePublicGroupUsersRequests } from "@/middleware/hooks/usePublicGroupUsersRequests";
import NotificationsListItem from "./NotificationListItem";

const NotificationItemSkeleton = () => (
  <div className="flex flex-col gap-2 truncate p-2 align-middle">
    <div className="flex items-center justify-start gap-2">
      <div className="size-10 shrink-0 animate-pulse rounded-full bg-muted" />
      <div className="h-9 w-full animate-pulse rounded-sm bg-muted" />
    </div>
    <div className="flex justify-end gap-3">
      <div className="h-9 w-16 shrink-0 animate-pulse rounded-md bg-muted" />
      <div className="h-9 w-16 shrink-0 animate-pulse rounded-md bg-muted" />
    </div>
  </div>
);

export default function NotificationsListView() {
  const { t } = useTranslation();
  const {
    publicGroupUsersRequests,
    requestCount,
    isLoadingPublicGroupUsersRequests,
    loadingPublicChats,
  } = usePublicGroupUsersRequests();

  return (
    <div className="relative flex size-full flex-col overflow-hidden">
      <div className="flex h-leftColumnHeaderHeight shrink-0 items-center border-b border-primary/20 px-4">
        <h1 className="text-lg font-semibold">{t("notifications")}</h1>
      </div>

      {(isLoadingPublicGroupUsersRequests || loadingPublicChats) && (
        <>
          <NotificationItemSkeleton />
          <NotificationItemSkeleton />
        </>
      )}

      {!isLoadingPublicGroupUsersRequests &&
        !loadingPublicChats &&
        requestCount === 0 && (
          <div className="flex flex-1 items-center justify-center p-4 text-sm text-muted-foreground">
            {t("noNewNotifications")}
          </div>
        )}

      {requestCount > 0 && (
        <ScrollArea className="flex-1 p-2">
          {publicGroupUsersRequests
            .filter(({ requests }) => requests.length > 0)
            .map(({ chat, requests }) => (
              <div key={chat.id}>
                <ul className="">
                  {requests.map(({ username }) => {
                    return (
                      <NotificationsListItem
                        key={username}
                        chatId={chat.id}
                        chatName={chat.name}
                        username={username}
                      />
                    );
                  })}
                </ul>
              </div>
            ))}
          <ScrollBar orientation="vertical" />
        </ScrollArea>
      )}
    </div>
  );
}
